import React, { useState, useEffect } from "react";


import moment from "moment-timezone";

function CurrentDateTime() {

    const [currentAppointmentDate, setCurrentAppointmentDate] = useState(moment().format("DD MMMM YYYY"));
    const [currentAppointmentTime, setCurrentAppointmentTime] = useState(moment().format("HH:mm:ss"));
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentAppointmentDate(moment().format("DD MMMM YYYY"));
        setCurrentAppointmentTime(moment().format("HH:mm:ss"));
      }, 1000); // Update every second
      return () => clearInterval(interval);
    }, []);

    return(
       
        <div
  className=" col-md-12 text-end fw-bold  text-white"
  style={{
    position: "absolute",
    top: "10px",
    right: "10px",
     // Light background for readability
    padding: "5px 10px",
    borderRadius: "5px",
    zIndex: 1000, // Ensures it stays above other elements
  }}
>
  {currentAppointmentDate} {currentAppointmentTime}
</div>   
       
    )


}

export default CurrentDateTime;